import { type LabeledValue } from '@volumental/common';
import { type TFunction } from 'i18next';
import { SizeLocale } from '../../../api/gql/graphql';
import { UserError } from '../../../types/types';

export const generateSizeList = (
  local: SizeLocale,
): LabeledValue<number | undefined>[] => {
  let min: number;
  let max: number;
  const step = 0.5;
  switch (local) {
    case SizeLocale.Uk: {
      min = 2;
      max = 16;
      break;
    }
    case SizeLocale.Us:
    case SizeLocale.UsMen:
    case SizeLocale.UsWomen:
    case SizeLocale.Au: {
      min = 4;
      max = 18;
      break;
    }
    case SizeLocale.Eu: {
      min = 34;
      max = 50;
      break;
    }
    default: {
      min = 34;
      max = 50;
      break;
    }
  }
  const indexList: LabeledValue<number | undefined>[] = [];
  for (let i = min; i <= max; i += step) {
    indexList.push({
      label: `${local} ${i.toString()}`,
      value: i,
    });
  }
  return indexList;
};

export interface ErrorInterface {
  title: string;
  bulletPoints: string[];
}

export const defaultGenderIndex = (
  genderSegments: {
    value: string;
    label: string;
  }[],
  gender?: string,
): number =>
  gender ? genderSegments.findIndex((item) => item.value === gender) : 0;

export const getErrorDetailsFromUserError = (
  t: TFunction,
  userError?: UserError,
): ErrorInterface => {
  switch (userError) {
    case UserError.NoPaper: {
      return {
        title: t('reconstructionAlert.noPaper.title'),
        bulletPoints: t('reconstructionAlert.noPaper.bulletPoints', {
          returnObjects: true,
        }) as Array<string>,
      };
    }

    case UserError.NoFeet: {
      return {
        title: t('reconstructionAlert.noFeet.title'),
        bulletPoints: t('reconstructionAlert.noFeet.bulletPoints', {
          returnObjects: true,
        }) as Array<string>,
      };
    }
    case UserError.UnrecognizablePaper: {
      return {
        title: t('reconstructionAlert.unrecognizablePaper.title'),
        bulletPoints: t(
          'reconstructionAlert.unrecognizablePaper.bulletPoints',
          {
            returnObjects: true,
          },
        ) as Array<string>,
      };
    }

    case UserError.UnseenKeypoints: {
      return {
        title: t('reconstructionAlert.unseenKeypoints.title'),
        bulletPoints: t('reconstructionAlert.unseenKeypoints.bulletPoints', {
          returnObjects: true,
        }) as Array<string>,
      };
    }

    default: {
      return {
        title: t('reconstructionAlert.algoUnknown.title'),
        bulletPoints: t('reconstructionAlert.algoUnknown.bulletPoints', {
          returnObjects: true,
        }) as Array<string>,
      };
    }
  }
};
